import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

const HERO_IMG = "https://images.unsplash.com/photo-1761437856554-3072a8143bc3";

export const Slide1 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={0} total={total} onActive={onActive} label="Cover">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${HERO_IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.5,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black" />
      <div className="absolute inset-0 radial-gold opacity-80" />

      <div className="relative z-10 max-w-6xl px-6 md:px-12 w-full">
        <div className="overline mb-8" data-testid="hero-overline">{t.overline}</div>
        <h1 className="font-display font-medium text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] leading-[0.9] tracking-tighter">
          Brazilian
          <br />
          <span className="italic font-normal text-[var(--ph-accent)]">Rewards.</span>
        </h1>
        <p className="mt-10 max-w-2xl text-lg md:text-xl text-neutral-300 font-light leading-relaxed">
          {t.sub}
        </p>
        <div className="mt-12 flex items-center gap-6">
          <span className="pill" data-testid="hero-tag">{t.tag}</span>
          <div className="flex items-center gap-3 text-xs font-mono tracking-widest text-neutral-500">
            <span className="block w-12 h-[1px] bg-neutral-700" />
            {t.scroll.toUpperCase()}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 md:right-20 hidden md:block">
        <div className="text-right">
          <div className="font-mono text-[10px] tracking-widest text-neutral-500">PROOF</div>
          <div className="font-display text-4xl text-[var(--ph-accent)]">500+</div>
          <div className="font-mono text-[10px] tracking-widest text-neutral-500">DENSITY TARGET</div>
        </div>
      </div>
    </SlideShell>
  );
};


